"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
const diacritics_1 = __importDefault(require("./diacritics"));
function replaceSpecialCharacters(text) {
    const diacriticsMap = {};
    for (let i = 0; i < diacritics_1.default.length; i++) {
        const letters = diacritics_1.default[i].letters;
        for (let j = 0; j < letters.length; j++) {
            diacriticsMap[letters[j]] = diacritics_1.default[i].base;
        }
    }
    function replace(refinedText) {
        if (refinedText) {
            return refinedText.replace(/[^\u0000-\u007E]/g, function (a) {
                return diacriticsMap[a] || a;
            });
        }
        return refinedText;
    }
    return replace(text);
}
module.exports = replaceSpecialCharacters;
//# sourceMappingURL=index.js.map